import { defineMessages } from 'react-intl';

export default function Messages() {
  const messages = defineMessages({
    messages_mark_as_read: {
      id: 'messages_mark_as_read',
      defaultMessage: "Mark all new messages as read",
      description: '',
    },
    messages_group_title: {
      id: 'messages_group_title',
      defaultMessage: "Messages",
      description: '',
    },
    add_message_placeholder: {
      id: 'add_message_placeholder',
      defaultMessage: "Enter your message...",
      description: '',
    },
    send_new_message_title: {
      id: 'send_new_message_title',
      defaultMessage: "You are sending a message to",
      description: '',
    },
    send_reply_message_title: {
      id: 'send_reply_message_title',
      defaultMessage: "has sent you a message",
      description: '',
    },
    send_message_placeholder: {
      id: 'send_message_placeholder',
      defaultMessage: "Sent message",
      description: '',
    },
    send_message_send: {
      id: 'send_message_send',
      defaultMessage: "SEND",
      description: '',
    },
    send_message_skip: {
      id: 'send_message_skip',
      defaultMessage: "CANCEL",
      description: '',
    },
    load_previous_messages: {
      id: 'load_previous_messages',
      defaultMessage: "Load previous messages",
      description: '',
    },
    message_send_error_popup_title: {
      id: 'message_send_error_popup_title',
      defaultMessage: "Send message",
      description: '',
    },
    message_send_error_popup_msg: {
      id: 'message_send_error_popup_msg',
      defaultMessage: "Ups.. there was a problem while trying to send your message. Try again.",
      description: '',
    },
    message_main_title: {
      id: 'message_main_title',
      defaultMessage: "- messages",
      description: '',
    },
    message_new_info: {
      id: 'message_new_info',
      defaultMessage: "NEW MESSAGE",
      description: '',
    },
  });
  return messages;
}



// WEBPACK FOOTER //
// ./src/components/ConversationPopup/Messages.js